(function () {
  var SELECTOR_CONTAINER = '[data-newsletter-consent]';
  var SELECTOR_CHECKBOX = '[data-newsletter-consent-checkbox]';
  var SELECTOR_ERROR = '[data-newsletter-consent-error]';

  function showError(container) {
    var error = container.querySelector(SELECTOR_ERROR);
    if (error) {
      error.removeAttribute('hidden');
    }
  }

  function hideError(container) {
    var error = container.querySelector(SELECTOR_ERROR);
    if (error) {
      error.setAttribute('hidden', '');
    }
  }

  function isCheckboxChecked(container) {
    var cb = container.querySelector(SELECTOR_CHECKBOX);
    return cb && cb.checked;
  }

  function initContainer(container) {
    if (container.dataset.consentInit) return;
    container.dataset.consentInit = 'true';

    var form = container.closest('form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      if (!isCheckboxChecked(container)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError(container);
        var checkbox = container.querySelector(SELECTOR_CHECKBOX);
        if (checkbox) {
          try { checkbox.focus({ preventScroll: true }); } catch (ex) { checkbox.focus(); }
          checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }, true);

    var checkbox = container.querySelector(SELECTOR_CHECKBOX);
    if (checkbox) {
      checkbox.addEventListener('change', function () {
        if (checkbox.checked) hideError(container);
      });
    }
  }

  function initAll() {
    var containers = document.querySelectorAll(SELECTOR_CONTAINER);
    for (var i = 0; i < containers.length; i++) {
      initContainer(containers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
